import { Button, Grid } from "@mui/material";
import { contactApiKeyStore } from "../../../../api/contact-api-key-store";
import { SiTrackGrid } from "../../../../components/si-track-grid/si-track-grid";
import { GridColumnConfig } from "../../../../models/gridCoumnConfig";
import { UserPermissionName } from "../../../../models/user-permission-name";
import React, { useState } from "react";
import { workOrdersApiKeyStore } from "../../../../api/workorders-api-key-store";
import { useSaveData } from "../../../../hooks/useSaveData";

const columns: GridColumnConfig[] = [
    {
        title: 'Title',
        field: 'contactsTitle',
        filter: 'text',
        searchable: true,
        width: '100px'
    },
    {
        title: 'Contact Name',
        field: 'contactsFullName',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Work Email',
        field: 'contactsWorkEmail',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Cell Phone',
        field: 'contactsOfficePhone',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Option',
        field: 'option',
        filter: 'text',
        width: '155',
        searchable: false,
        isGroupable: false,
        isHideColumnMenu: true
    },
];

interface CellProps {
    contactData: any;
    workOrderID: any;
}

interface CustomGridCellProps {
    field: string;
}

interface DuxContactsComponent {
    customerID: any;
    workOrderID: any;
    onDuxCall: () => void;
    onClosed: () => void;
}
export const DuxContactsComponent = ({ customerID, workOrderID, onDuxCall, onClosed }: DuxContactsComponent) => {

    const { isLoading, mutateAsync } = useSaveData(workOrdersApiKeyStore.workOrderDuxSMS(),
        () => contactApiKeyStore.getCustomerContacts(customerID));

    const handleSendDuxSms = async (contactsID: any, workOrderID: any) => {
        const data = {
            contactID: contactsID,
            workOrderID: workOrderID,
        };
        const smsResponse = await mutateAsync({ data: data });
        // Cast data to any to silence TS errors for dynamic keys
        const responseData: any = smsResponse?.data;
        const duxAdHocCallGuid = responseData?.duxAdHocCallGuid;
        const returnedWorkOrderID = responseData?.workOrderID;
        // Call Azure Function with query params if both values exist
        try {
            const functionUrl = process.env.REACT_APP_DUX_ADHOC_CALL_URL;
            if (functionUrl && duxAdHocCallGuid && returnedWorkOrderID) {
                const url = `${functionUrl}&DuxAdHocCallGuid=${encodeURIComponent(duxAdHocCallGuid)}&WorkOrderID=${encodeURIComponent(returnedWorkOrderID)}`;
                await fetch(url, { method: 'POST' });
            }
        } catch (err) {
            console.error('Azure Function call failed', err);
        }
        onDuxCall();
    };

    const EditCell = React.memo(({ contactData, workOrderID }: CellProps) => {
        const [hovered, setHovered] = useState(false);
        const handleMouseOver = () => {
            setHovered(true);
        };
        const handleMouseOut = () => {
            setHovered(false);
        };

        const buttonStyle = {
            color: 'white',
            backgroundColor: hovered ? '#0000b5' : '#0000b5',
            padding: '8px',
            maxHeight: '28px',
        };

        return (
            <td className="stickyCloumn">
                <div className="actionWidth">
                    <Button
                        onClick={() => handleSendDuxSms(contactData?.dataItem?.contactsID, workOrderID)}
                        className="btn btn-primary btn-sm sitDefaultBtn"
                        style={buttonStyle}
                        onMouseOver={handleMouseOver}
                        onMouseOut={handleMouseOut}
                    >
                        SEND DUX SMS
                    </Button>
                </div>
            </td>
        );
    });

    const customGridCell = ({ field }: CustomGridCellProps): ((dataItem: any) => JSX.Element) | undefined => {
        if (field === 'option') {
            return (dataItem: any) => {
                return <EditCell contactData={dataItem} workOrderID={workOrderID} />;
            };
        }
        // Return undefined if the field is not 'bluePrint'
        return undefined;
    };

    return (
        <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <SiTrackGrid
                    fileTitle='schedule_dux_contacts'
                    dataItemKey="contactsID"
                    columns={columns}
                    currentPageSize={10}
                    customCell={(field) =>
                        customGridCell?.({
                            field,
                        })
                    }
                    queryConfig={contactApiKeyStore.getCustomerContacts(customerID)}
                    actionPermissions={{
                        export: UserPermissionName.DOWNLOAD_GRID,
                    }}
                    isBusy={isLoading}
                />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Button variant="outlined" onClick={onClosed} style={{ width: '130px' }}>
                    {' '}
                    Cancel
                </Button>
            </Grid>
        </Grid>
    );
}